import { API_USER_URL } from "@/env";
import { message } from "antd";
import { TransactionAdminAPI, TransactionDetailAPI } from "./type";

const API_USE = API_USER_URL || '';

async function getTransactionList_Admin(page: number = 1, pageSize: number = 10, status?: string, search?: string, user_id?: number, transaction_type?: string): Promise<TransactionAdminAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const queryParams = new URLSearchParams();
        queryParams.append('page', page.toString());
        queryParams.append('per_page', pageSize.toString());
        if (status) queryParams.append('status', status); //succeed, failed
        if (search) queryParams.append('search', search);
        if (user_id !== undefined) queryParams.append('user_id', user_id.toString());
        if (transaction_type) queryParams.append('type', transaction_type); // investment.profit,commission,refund
        const response = await fetch(`${API_USE}/api/v1/be/admin/transactions?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });
        if (!response.ok) {
            message.error('Error fetching transactions list');
        }
        const data = await response.json();
        return data as TransactionAdminAPI;
    } catch (error) {
        console.error('Failed to fetch transactions list:', error);
        throw error;
    }
}

async function approveTransaction_Admin(id: number, message?: string, received_amount?: number, refund_amount?: number): Promise<any> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/transactions/approve/${id}`, {
            method: 'POST', // or PUT depending on backend
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ admin_note: message || '', received_amount: received_amount || 0, refund_amount: refund_amount || 0 })
        });
        if (!response.ok) {
            throw new Error('Failed to approve transaction');
        }
        return await response.json();
    } catch (error) {
        console.error('Failed to approve transaction:', error);
        throw error;
    }
}

async function rejectTransaction_Admin(id: number, message: string, refund_amount?: number): Promise<any> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/transactions/reject/${id}`, {
            method: 'POST', // or PUT
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ admin_note: message, refund_amount: refund_amount || 0 })
        });
        if (!response.ok) {
            throw new Error('Failed to reject transaction');
        }
        return await response.json();
    } catch (error) {
        console.error('Failed to reject transaction:', error);
        throw error;
    }
}

async function getAdminTransationStatistics(): Promise<any> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/transactions/stats`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });
        if (!response.ok) {
            message.error('Error fetching transaction statistics');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to fetch transaction statistics:', error);
        throw error;
    }
}
async function fetchTransactionDetails_Admin(id: number): Promise<TransactionDetailAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/transactions/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });
        if (!response.ok) {
            message.error('Error fetching transaction details');
        }
        const data = await response.json();
        return data as TransactionDetailAPI;
    } catch (error) {
        console.error('Failed to fetch transaction details:', error);
        throw error;
    }
}
export { getTransactionList_Admin, approveTransaction_Admin, rejectTransaction_Admin, getAdminTransationStatistics, fetchTransactionDetails_Admin };